import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdf8f642"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "installment" }
const _hoisted_2 = { class: "installment_header header" }
const _hoisted_3 = { class: "installment_row" }
const _hoisted_4 = { class: "header_title" }
const _hoisted_5 = { class: "installment_row" }
const _hoisted_6 = { class: "header_next-pay" }
const _hoisted_7 = { class: "header_first-pay" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "installment_divider" }, null, -1))
const _hoisted_9 = { class: "installment_content" }
const _hoisted_10 = { class: "installment_column remains" }
const _hoisted_11 = { class: "installment_row" }
const _hoisted_12 = { class: "remains_title" }
const _hoisted_13 = { class: "installment_row" }
const _hoisted_14 = { class: "progress" }
const _hoisted_15 = { class: "installment_column payment-info" }
const _hoisted_16 = { class: "installment_column" }
const _hoisted_17 = { class: "payment-info_title" }
const _hoisted_18 = { class: "payment-info_content" }
const _hoisted_19 = { class: "installment_column" }
const _hoisted_20 = { class: "payment-info_title -right" }
const _hoisted_21 = { class: "payment-info_content -right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.installment.title), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.nextPayText) + ": " + _toDisplayString(_ctx.nextPayDateFromatted), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('installments.paymentIssued')) + ": " + _toDisplayString(_ctx.createdAtFromatted), 1)
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('installments.left')), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: _normalizeClass(["remains_amount", {
              '-paid': _ctx.installment.isPaid
            }])
          }, [
            _createTextVNode(_toDisplayString(_ctx.amountFormatting(_ctx.amountIsLeft)) + " " + _toDisplayString(_ctx.currency) + " ", 1),
            _createElementVNode("i", null, "из " + _toDisplayString(_ctx.amountFormatting(_ctx.installment.totalAmount)) + " " + _toDisplayString(_ctx.currency), 1)
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installment.numberOfCompletedPayments, (n) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `progress-paid-${n}`,
            class: "progress_part -active"
          }))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.numberOfPayments - _ctx.installment.numberOfCompletedPayments), (n) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `progress-left-${n}`,
            class: "progress_part"
          }))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.paymentPeriodText), 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.amountFormatting(_ctx.installment.recurrentAmount)) + " " + _toDisplayString(_ctx.currency), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('installments.left')), 1),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.numberOfPaymentsIsLeft) + " " + _toDisplayString(_ctx.paymentsLeftText), 1)
        ])
      ])
    ])
  ]))
}